// extracted by mini-css-extract-plugin
export default {"root":"CreateSupportTicketOverlay_root__gwLtx","container":"CreateSupportTicketOverlay_container__xcJ08"};